import { decimalSeparator } from './decimalSeparator';

export const formatPercentage2 = (x, dig = 2) => {
  const k = Math.pow(10, dig);
  const newData = x ? `${(Math.round(x * k) / k).toFixed(dig)?.replace('.', decimalSeparator())}` : x === 0 ? '0.00'?.replace('.', decimalSeparator()) : '';
  return newData;
};
